import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { cards as Cards } from '@breezeway/brzw-components';
import { TASK_READY_TYPE_STATUS } from '../../../utils/task';

import './info.scss';

const { CARD_INFO_TOGGLE_COLORS } = Cards.InfoConstants;

const getReadyStatusColor = code => {
  switch (code) {
    case TASK_READY_TYPE_STATUS.IN_PROGRESS:
      return CARD_INFO_TOGGLE_COLORS.GREEN;

    case TASK_READY_TYPE_STATUS.READY:
      return CARD_INFO_TOGGLE_COLORS.DARK_GREEN;

    case TASK_READY_TYPE_STATUS.OCCUPIED:
      return CARD_INFO_TOGGLE_COLORS.GRAY;

    case TASK_READY_TYPE_STATUS.DIRTY:
      return CARD_INFO_TOGGLE_COLORS.ORANGE;

    default:
      return null;
  }
};

const Info = ({ infoButtons }) => {
  const infoCards = _.map(infoButtons, (info, index) => {
    const { active, className, onClick, status, startNumber, endNumber } = info;
    return (
      <Cards.Info
        active={active}
        className={className}
        endNumber={endNumber}
        key={index}
        onClick={onClick}
        startNumber={startNumber}
        statusColor={getReadyStatusColor(status.code)}
        text={status.name}
      />
    );
  });

  return (
    <div className="cards-info">
      <div className="cards-info__position">{infoCards}</div>
    </div>
  );
};

Info.propTypes = {
  infoButtons: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      className: PropTypes.string,
      endNumber: PropTypes.number,
      onClick: PropTypes.func,
      startNumber: PropTypes.number,
      status: PropTypes.shape({
        code: PropTypes.string,
        name: PropTypes.string,
      }),
    }),
  ),
};

export default Info;
